import { Card, CardActions, CardContent, Typography } from "@mui/material";
import { IItem } from "../../types/IItem";
import { FunctionComponent } from "react";
import { getItemLabel } from "../../utils/commonHelpers";
import NumberSelector from "../../components/NumberSelector/NumberSelector";
import { Delete } from "@mui/icons-material";

interface OrderItemCardProps {
  orderItem: { item: IItem; quantity: number };
  onQuantityChange: (itemId: string, quantity: number) => void;
  onDeleteItem: (itemId: string) => void;
}

const OrderItemCard: FunctionComponent<OrderItemCardProps> = ({
  orderItem,
  onQuantityChange,
  onDeleteItem,
}) => {
  return (
    <Card
      className="order-item-card"
      key={orderItem.item.id}
      variant="outlined"
    >
      <CardContent>
        <Typography variant="subtitle1" component="div" fontWeight={"bold"}>
          {getItemLabel(orderItem.item)}
        </Typography>
        <Typography sx={{ color: "text.secondary", mb: 1.5 }} variant="caption">
          {orderItem.item.id}
        </Typography>
        <Typography variant="body2">
          {(orderItem.item.base_price * orderItem.quantity).toFixed(2)} (
          {`${orderItem.item.base_price.toFixed(2)}/each`})
        </Typography>
      </CardContent>
      <CardActions className="card-actions">
        <NumberSelector
          value={orderItem.quantity}
          onChange={(value) => onQuantityChange(orderItem.item.id, value)}
        />

        <Delete
          color="error"
          className="icon"
          onClick={() => onDeleteItem(orderItem.item.id)}
        />
      </CardActions>
    </Card>
  );
};

export default OrderItemCard;
